<template>
    <van-popup v-model:show="showPicker" destroy-on-close round position="bottom" :style="{ height: '50%' }">
        <van-picker
            v-model:selected-index="selectedIndex"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        />
    </van-popup>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { http } from '@/request/http'

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => []
    },
    cascade: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const showPicker = ref(false)
const categoryList = ref([])
const selectedIndex = ref([])

const columns = computed(() => {
    if (!props.cascade) {
        return categoryList.value.map(item => ({
            text: item.name,
            value: item.id
        }))
    }

    const formatCascade = (list, level = 0) => {
        return list.map(item => {
            const column = {
                text: item.name,
                value: item.id,
                children: item.children && item.children.length > 0
                    ? formatCascade(item.children, level + 1)
                    : undefined
            }
            return column
        })
    }

    const columns = formatCascade(categoryList.value)
    columns.unshift({
        text: '全部',
        value: '',
        children: [
            {
                text: '全部',
                value: ''
            }
        ]
    })
    return columns
})

const openPicker = () => {
    showPicker.value = true
}

const onConfirm = ({ selectedOptions }) => {
    showPicker.value = false
    emit('update:modelValue', selectedOptions.map(opt => ({
        id: opt.value,
        name: opt.text
    })))
    emit('confirm', selectedOptions.map(opt => ({
        id: opt.value,
        name: opt.text
    })))
}

const fetchCategoryList = () => {
    http.get('/app-api/product/category/treeList').then(res => {
        categoryList.value = res || []
    })
}

watch(showPicker, (val) => {
    if (val && categoryList.value.length === 0) {
        fetchCategoryList()
    }
})

defineExpose({
    openPicker
})
</script>
